<template>
    <div>
        <oss-data-table :headers="headers" :items="items" :striped="true">
            <template #item.rule="{ item }">
                <!-- <v-icon>{{ itemIcon(item.type) }}</v-icon> -->
                <span>{{ item.rule }}</span>
            </template>
        </oss-data-table>
    </div>
</template>

<script lang="ts">
import OssDataTable from "../ossComponents/ossDataTable2.vue";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Model } from "vue-facing-decorator";

@Component({
    components: {
        OssDataTable,
    },
    emits: ["scopedCompanies"],
})
export class ScopeParents extends Vue {
    @Prop({ type: String }) id!: string;

    // @Model({ name: "search" }) searchSync!: string;

    @Model({ name: "partitionTags" }) partitionTagsSync!: any[];
    @Model({ name: "accountingReviewLayout" }) accountingReviewLayoutSync!: any[];
    @Model({ name: "documentRules" }) documentRulesSync!: any[];
    @Model({ name: "exportOffice" }) exportOfficeSync!: any[];
    @Model({ name: "bookletTemplate" }) bookletTemplateSync!: any[];
    @Model({ name: "exportTheme" }) exportThemeSync!: any[];
    @Model({ name: "extensions" }) extensionsSync!: any[];
    @Model({ name: "accountableAccountTables" }) accountableAccountTablesSync!: any[];
    @Model({ name: "bankTransactionWordingPatterns" }) bankTransactionWordingPatternsSync!: any[];
    @Model({ name: "operatingAccounts" }) operatingAccountsSync!: any[];
    @Model({ name: "computedIndicators" }) computedIndicatorsSync!: any[];
    
    get headers() {
        return [
            { text: "Règle", value: "rule" },
            { text: "Nom", value: "name", width: "70%" }
        ];
    }

    get items() {
        const items: any[] = [];
        if (this.partitionTagsSync) {
            const partitionTags = this.partitionTagsSync.map((pt) => ({
                rule: "Partition générique",
                name: pt.name,
            }));
            items.push(...partitionTags);
        }

        if (this.accountingReviewLayoutSync) {
            const accountingReviews = this.accountingReviewLayoutSync.map((arl) => ({
                rule: "Dossier de révision",
                name: arl.name,
            }));
            items.push(...accountingReviews);
        }

        if (this.documentRulesSync) {
            const documentRules = this.documentRulesSync.map((dr) => ({
                rule: "Règle sur les factures",
                name: dr.name,
            }));
            items.push(...documentRules);
        }

        if (this.exportOfficeSync) {
            const exportOffice = this.exportOfficeSync.map((eo) => ({
                rule: "Export office",
                name: eo.name,
            }));
            items.push(...exportOffice);
        }

        if (this.bookletTemplateSync) {
            const bookletTemplates = this.bookletTemplateSync.map((bt) => ({
                rule: "Plaquette",
                name: bt.name,
            }));
            items.push(...bookletTemplates);
        }

        if (this.exportThemeSync) {
            const exportThemes = this.exportThemeSync.map((et) => ({
                rule: "Thème document",
                name: et.name,
            }));
            items.push(...exportThemes);
        }

        if (this.extensionsSync) {
            const extensions = this.extensionsSync.map((e) => ({
                rule: "Extension",
                name: e.name,
            }));
            items.push(...extensions);
        }
        
        if (this.accountableAccountTablesSync) {
            const accountableAccountTables = this.accountableAccountTablesSync.map((aat) => ({
                rule: "Plan comptable",
                name: aat.name,
            }));
            items.push(...accountableAccountTables);
        }
        
        if (this.bankTransactionWordingPatternsSync) {
            const wordingAnalysis = this.bankTransactionWordingPatternsSync.map((bt) => ({
                rule: "Analyse de libellé",
                name: bt.name,
            }));
            items.push(...wordingAnalysis);
        }
        
        if (this.operatingAccountsSync) {
            const operatingAccounts = this.operatingAccountsSync.map((oa) => ({
                rule: "Tableau personnalisé",
                name: oa.name,
            }));
            items.push(...operatingAccounts);
        }
        
        if (this.computedIndicatorsSync) {
            const computedIndicators = this.computedIndicatorsSync.map((ci) => ({
                rule: "Indicateur personnalisé",
                name: ci.definition?.values[0]?.displayName || "",
            }));
            items.push(...computedIndicators);
        }

        // if (this.searchSync) {
        //     const search = this.searchSync.toLowerCase();
        //     return items.filter((i) => i.name.toLowerCase().includes(search));
        // }
        return items;
    }
}

export default toNative(ScopeParents);
</script>
